<form
  class="field-dialog__content__scroll p-24"
  fxLayout="column"
  name="form"
  [formGroup]="locationGroupForm"
  fusePerfectScrollbar
>
  <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="legacy" fxFlex="100">
      <mat-label>{{ 'LOCATIONS_GROUPS.HEADER.NAME' | translate }}</mat-label>
      <mat-hint align="end"> {{ locationGroupForm.get('name').value?.length || 0 }}/100 </mat-hint>
      <input matInput formControlName="name" required />
      <mat-error *ngIf="locationGroupForm.get('name').hasError('required')">
        {{ 'LOCATIONS_GROUPS.ERRORS.NAME_REQUIRED' | translate }}
      </mat-error>
      <mat-error *ngIf="locationGroupForm.get('name').hasError('location_group_name_duplicated')">
        {{ 'LOCATIONS_GROUPS.ERRORS.NAME_DUPLICATED' | translate }}
      </mat-error>
      <mat-error *ngIf="locationGroupForm.get('name').hasError('maxlength')">
        {{ 'LOCATIONS_GROUPS.ERRORS.NAME_MAX_LENGTH' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div xLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="legacy" fxFlex="100">
      <textarea
        matInput
        matTextareaAutosize
        placeholder="Descrição"
        matAutosizeMinRows="2"
        matAutosizeMaxRows="3"
        formControlName="description"
      ></textarea>
    </mat-form-field>
  </div>
</form>
